module.exports = __webpack_public_path__ + "instacart.svg?69cd142a1246600fa0b809fb5d623939";